const transactionMessagesViewTemplate = `
<!-- Optional column that shows when there are transactional messages available -->
<div id="messagesColumn"
     ng-class="[transactionMessagesController.layoutPosition, {'col-sm-12 col-md-3 col-lg-3'  : transactionMessagesController.layoutPosition == 'right'}]" 
     ng-if="transactionMessagesController.showMessagesColumn()">

    <div class="things-to-know-container">
        <div class="row">
            <div class="col things-header">
                <span class="em-lightbulb-circle"></span>
                <span role="heading" class="things-header-text" aria-level="3">{{ 'accountList.thingsToKnow' | translate }}</span>
            </div>
        </div>
        <div class="row">
            <div class="col things-body">
               <span ng-if="transactionMessagesController.showWithdrawalLink === false">
                <p show-more-or-less="transactionMessagesController.transactionMessages"
                chars-threshold="200"
                disable-scroll="transactionMessagesController.disableScroll">
             </p>
               </span>
               <span ng-if="transactionMessagesController.showWithdrawalLink === true">
                <a ng-click="transactionMessagesController.openPopUpForAmFunds()">Withdrawal information</a>
                </span>
            </div>
        </div>
    </div>

</div>
`;
export default transactionMessagesViewTemplate;
